module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("2")])])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "chaphead-image2"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line1.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("The Riot")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("B")]), _vm._v("y Thursday, March 28, the freak snowstorm seemed a distant memory. The weather had turned hot. It was already in the low eighties by 8:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., when a large crowd of marchers gathered at Clayborn Temple. A contingent of Invaders was already there. They were a gang of college-age radicals who carried the mantle of black activism, but the police suspected this was a cover for petty crimes. Recently, with the advent of the sanitation strike, the Invaders had taken the community’s most militant stands.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("King was supposed to arrive at 9:00, but his plane from New York was late. “People were restless,” remembers the Reverend Billy Kyles. “And some of the Invaders started working the crowd. ‘We don’t need anything peaceful,’ they said. I knew there was trouble brewing and felt we’d better start the march without King. But Jim Lawson overruled me and said we should wait for King. I knew that was a mistake.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-1",
      "id": "ch02-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" King’s car did not arrive until nearly 11:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We had planned to go inside and ‘work-shop’ the people in the theory and techniques of non-violence,” recalled Abernathy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-2",
      "id": "ch02-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Young men crowded around the car, initially making it impossible for King to step outside. Bernard Lee, one of King’s aides, recognized them as Invaders. “They’re a bunch of troublemakers who are trying to horn in on the march,” he said. Lawson worked his way through the crowd. “The only way we’ll get away from them is to get out and start the march,” he said."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-3",
      "id": "ch02-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" So King and the others got out of the car. King "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("linked arms with Abernathy and Bishop Julian Smith of the Methodist Episcopal Church, and they started off, singing “We Shall Overcome.” Riot police remained out of sight so they would not incite the crowd."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-4",
      "id": "ch02-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" It was a few minutes after 11:00.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I stayed in the back to give some direction,” says Kyles. “Before everyone had even left the church, young thugs had ripped the sticks off their placards to use as clubs.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-5",
      "id": "ch02-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“After a few blocks,” recalled Abernathy, “we heard what sounded like gunshots, though we later learned it was the smashing of glass windows. The Invaders had used the cover of our march to commit acts of violence.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-6",
      "id": "ch02-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I heard a police walkie-talkie,” says Kyles. “‘The Negroes are looting the stores. Permission to break up the march.’ Then a slight pause. ‘Permission granted.’ The police just rioted. They made no attempt to find out who were rioters, looters, or peaceful demonstrators.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-7",
      "id": "ch02-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The melee that followed quickly eroded into bedlam, with police—some having removed their badges and identification numbers—chasing any black demonstrator they could find. Young rabble-rousers continued shattering store windows and grabbing whatever merchandise they could carry, while those who had come to march legitimately in support of the strikers fled in panic. Lawson excitedly told King that for his own safety he had to leave immediately."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-8",
      "id": "ch02-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" A line of state troopers was gathering in front of King and his aides, effectively hemming them in. But then a Pontiac driven by a black woman pulled up to the nearest corner, and King, Lee, and Abernathy pushed their way to the car and pleaded to be allowed inside."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-9",
      "id": "ch02-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Recognizing them, she let them into the car and the police moved aside, allowing them to pass. As the car approached the Mississippi River, the group saw two policemen and pulled over to seek help.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are you trying to go?” one of the policemen asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Peabody Hotel.” Union officials had rented a room for them there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forget it. There’s pandemonium at the Peabody.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What about the Lorraine?” That was the black-owned motel at which King and his entourage normally stayed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Pandemonium there. As a matter of fact, we’ve declared a curfew. We’re going to clear the streets. Follow us.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-10",
      "id": "ch02-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The police took King and his aides to the Rivermont Holiday Inn, a luxury hotel on the river."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn02-02-1",
      "id": "fn02-1"
    }
  }, [_vm._v("*")]), _vm._v(" It was only there, when King turned on the television and saw live coverage of the riot, that he realized how serious the situation was. The police "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("had shot and killed a sixteen-year-old Invader. Scores were hurt, including five shot and one stabbed. Three hundred were arrested."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-11",
      "id": "ch02-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v(" Every window in a two-block stretch of historic Beale Street was smashed. By mid-afternoon, after a series of pitched street battles between riot police armed with tear gas and black students showering them with bricks and bottles, Governor Buford Ellington ordered four thousand National Guardsmen into the city, complete with armored personnel carriers. More than a hundred fires broke out in downtown Memphis, many the result of arson. Mayor Loeb instituted a strict 7:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". to 5:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". curfew; police allowed people on the streets only to go to or from work."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-12",
      "id": "ch02-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This is terrible,” King said, wringing his hands and shaking his head in disbelief. “Now we will never get anybody to believe in nonviolence.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s not our fault, Martin,” said Abernathy, trying hard to reassure himself as much as King. “Those young men—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It doesn’t matter who did it,” King shouted. “We’ll get the blame.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-13",
      "id": "ch02-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" He was as despondent as Abernathy had ever seen him. “He was extremely depressed,” agrees Kyles, who visited him later at the hotel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-14",
      "id": "ch02-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What worried King and his aides was that the violence in Memphis could be a deathblow to his Poor People’s Campaign. “Maybe we just have to admit that the day of violence is here,” King remarked to Abernathy, “and maybe we have to just give up and let violence take its course. The nation won’t listen to our voice—maybe it’ll heed the voice of violence.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-15",
      "id": "ch02-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was already finger-pointing among King’s aides as to why they had even allowed him to march for the strikers. “If we made a mistake, it was in going to Memphis at all,” declared King’s chief aide, Andrew Young."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-16",
      "id": "ch02-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time Lawson visited King at the Rivermont later that night, King was resting in bed. He was scheduled to leave the next morning, but already he wanted to return soon to lead another demonstration. “If we don’t have a peaceful march in Memphis, no Washington,” King said. “No Memphis, no Washington.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-17",
      "id": "ch02-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Lawson and King decided to hold a press conference the following morning, where they would announce their intent to have a new march. King agreed to pull some of his aides off the Poor People’s Campaign and send them to Memphis to conduct nonviolence workshops before he returned."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-18",
      "id": "ch02-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("King did not get to sleep until nearly 4:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". The next morning he met with some of the Invaders who arrived to offer their apologies. The press conference started near noon. Abernathy later said that it was “perhaps his finest performance with the press.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-19",
      "id": "ch02-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" He was witty, precise, and honest about the "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("problems in the previous day’s march. He told the reporters he hoped to return in “three or four days” for another demonstration.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line.jpg"
    }
  })])])]), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("About the time King was holding his press conference in Memphis, a man walked into the Long-Lewis hardware store in Bessemer, Alabama, some ten miles outside Birmingham. The store’s manager, Mike Kopp, remembered him as a young white man, dressed in a dark brown suit, a blue and yellow pinstriped shirt, and a green tie. He had dark hair, a thin nose, manicured nails, and thick horn-rimmed glasses."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-20",
      "id": "ch02-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you handle high-powered rifles?” the stranger asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Kopp said yes, and offered to show him a .30-30.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That wouldn’t be powerful enough.” The man had a soft voice, but pronounced each word clearly. There was no noticeable accent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-21",
      "id": "ch02-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Instead, the customer asked about a .243, .308, and .30-06. He wanted to know the prices of each as well as how many inches the bullet might drop at 600 yards. He also inquired about 6.5mm ammunition that might fit a Japanese rifle. At one point, Kopp took a Browning off the rack, and the customer opened and closed the bolt action."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-22",
      "id": "ch02-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The customer also asked about scopes and how long it would take Kopp to mount one. When informed that it would take two days—Kopp sent his rifles to Birmingham for mounting scopes—the man asked for names of other local stores that might carry high-powered rifles.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he was leaving, the customer stopped near a large mounted moose head. “That’s a nice trophy. I once tried to bring one down, but I missed.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-23",
      "id": "ch02-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" To Kopp, the man seemed “weak,” and with his pale, almost sickly, complexion, not the outdoors type. He looked around some more. “I might come back here,” he said, as he walked out the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three hours later, at Aeromarine Supply Company, across the road from Birmingham’s municipal airport, John DeShazo, a twenty-five-year-old gun enthusiast, was leaning across a counter waiting for his friend, Don Wood, the owner’s son, to return from lunch. Aeromarine Supply, a sprawling, single-story warehouse-style building, had one of the largest gun selections in the South. DeShazo thought the man who walked in, in a wrinkled brown suit and thick horn-rims, seemed out of place in the store. He could have been a salesman."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-24",
      "id": "ch02-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He meekly approached one of the clerks, Hugh Baker, and asked to examine a Remington Gamemaster .243 rifle. By the way he handled it, DeShazo concluded that he did not know much about guns. Then the customer asked to examine a Browning .243 safari-grade rifle and a Remington .30-30 caliber. “Have you got a scope for this?” the man asked, pointing to the Remington "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v(".243. He quickly settled on a premier Redfield 2 x 7 scope. After discussing price for a moment, Baker told the man that if he could wait, the store would mount and calibrate the scope. He agreed."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-25",
      "id": "ch02-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he watched the entire transaction, DeShazo became aggravated. He is the type of person, DeShazo thought, who buys a rifle, kills his wife, and then gives all weapons a bad name."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-26",
      "id": "ch02-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" He has no business buying a rifle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("DeShazo walked up to him. Although the man was not visibly drunk, he smelled of alcohol. “You’ve really got quite a gun there—you’ll have to learn how to use it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-27",
      "id": "ch02-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" The man gave a crooked smile, almost a smirk. As DeShazo recalled, the man said that his brother, or perhaps brother-in-law, had invited him to go deer hunting in Wisconsin. He walked away from DeShazo and started filling in the store’s purchase form, giving his name as Harvey Lowmeyer and his address as 1907 South Eleventh Street in Birmingham. He paid the $248.59 bill in cash."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-28",
      "id": "ch02-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As he was ready to leave, his salesman explained to him that the original box for the Remington could no longer be used since the scope made it too large to fit inside, so instead the store fashioned a makeshift container from a large Browning gun box. The man left with the Remington box as well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("About 5:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(". that same day, Lowmeyer telephoned Aeromarine and reached Don Wood. “He stated that he had had a conversation with his brother,” recalled Wood, “and decided that the gun he had purchased was not the gun he wanted, and he requested whether he could exchange it for a Remington, Model 760, .30-06 caliber.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-29",
      "id": "ch02-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Wood said yes, but that it would cost another five dollars. That was all right, said Lowmeyer. When could he come in? Since the store was closing, Wood suggested the following day, Saturday, March 30.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lowmeyer was at Aeromarine when it opened at 9:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("A")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t you want the .243?” asked Wood. “It’s big enough to bring down any deer in Alabama.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I want to hunt bigger game in Wisconsin,” Lowmeyer quietly said."), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn02-02-2",
      "id": "fn02-2"
    }
  }, [_vm._v("*")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#ch02-02-30",
      "id": "ch02-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("Wood told him to return by 3:00 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P")]), _vm._v("."), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("M")]), _vm._v("., when he would have transferred the Redfield scope to the new gun. Lowmeyer came back in mid-afternoon and exchanged the box of .243 ammunition he had bought the earlier day for twenty rounds of Remington-Peters .30-06 Springfield high-velocity, 150-grain, soft-point Core-Lokt cartridges. Thanking Wood, Lowmeyer took his new package, got into a white Mustang parked outside, and drove away.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "image-left1"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "img",
      "src": "images/line2.jpg"
    }
  })])])]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn02-1",
      "id": "fn02-02-1"
    }
  }, [_vm._v("*")]), _vm._v(" The FBI tried to use King’s stay at the Rivermont to embarrass him. The Bureau had long conducted a relentless and at times illegal surveillance campaign against King. It later tried to get a “cooperative news source” to publicize the fact that “there was a first-class Negro hotel in Memphis, the Hotel Lorraine, but King chose to hide out in a white owned and operated Holiday Inn” [MLK FBI file 100-106670, section 94]. The following day, the Memphis "), _c('i', [_vm._v("Commercial Appeal")]), _vm._v(" had a cartoon depicting a petrified King fleeing the scene with the caption “Chicken-a-la-King.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnote1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn02-2",
      "id": "fn02-02-2"
    }
  }, [_vm._v("*")]), _vm._v(" The bolt of the .243 rifle was covered with hardened gun grease, and Lowmeyer evidently had trouble loading the weapon, so he decided to swap it for a different gun (CA, 4/5/93/Ct. Proceeding File). While the .243 was a good gun for hunting varmints and small deer, the pump-action Remington Gamemaster Model 760 .30-06-caliber rifle was a much more powerful weapon. Remington described it as “the fastest hand-operated big game rifle made.” The .30-06 bullets weigh nearly twice as much as the .243 ammo, travel 2,670 feet at 100 yards, and drop less than .01 of an inch in that distance. As opposed to a military, fully jacketed bullet designed to cut through flesh, giving the victim a chance of survival if no major organ is struck, a soft-point bullet expands on impact and is deliberately designed to rip flesh or organs with explosive violence. The rules of the Geneva Convention on ground warfare prohibit the use of soft-nosed slugs. The .30-06 bullet, hitting with an impact of over 2,000 pounds of energy, is strong enough to stop a charging rhinoceros at 100 yards, or to kill a man as far away as 1,500 yards. King was slain from a distance of 66 yards.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f8fa7de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 81
// module chunks = 0